<template>
  <f7-page class="page" id="transaction-history-page" name="transaction-history-page" @page:afterin="afterin">
    <f7-navbar class="view-mobile no-border">
        <f7-nav-left class="back-button">
          <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right></f7-nav-right>
    </f7-navbar>

    <f7-block>
        <div class="col-70 text-align-left mb-20">
          <div class="fs-24 fw-semibold">{{$t('general-text-activities')}}</div>
        </div>

        <!-- ALERT CARD -->
        <f7-card
          :title  ="$t(alertCard.title)"
          class  ="alert"
          :class ="alertCard.alertClass"
          id     ="successCard"
          v-show ="alertCard.show"
        >
            <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
        </f7-card>
        <div style="height:100%;width:100%" v-show="isShowEmptyScreen" >
        <div
        class="row no-gap w-100 display-flex align-items-center justify-content-center mb-xl mt-xl">
          <img style="height:200px"  :src="require('@/assets/img/icon/tx-icon.svg')"/>
          <div class="col-details">
          <div class="fs-18 fw-bold mt-4 text-align-center">You have no transfers at the moment.</div>
          <div class="wandr-caption-2 mt-2 text-align-center" style="">Experience the convenience of global money transfers with us. Take advantage of our easy-to-use platform and track all your transfers here.</div>
        </div>
      </div>

        </div>

      <!-- Transaction History -->
          <div class="infinite-scroll-content" @infinite="loadMore()">
            <div v-for="item in txnHistoryListViewModel" :key="item.id">
              <div class="fs-18 fw-semibold" v-if="!isCreatedInSameMonth(txnHistoryListViewModel.indexOf(item))" >{{item.createdMonth}}</div>
              <f7-list no-hairlines class="tx-history searchbar-found no-outlines">
                <f7-list-item :key="item.id" class="list-content-row" >

                  <div class="row no-gap w-100">
                    <div class="row no-gap w-100" @click="getTransactionDetail(item.transaction, item.statusName)" >
                      <div class="col-icon">
                        <img :src="require('@/assets/img/icon/icon-money-send.svg')"/>
                      </div>
                      <div class="col-details">
                        <div class="item-title mb-2">{{item.transaction.beneficiaryName}}</div>
                        <div class="wandr-caption-2" style="">{{item.createdDate}}</div>
                      </div>

                      <div class="col-status">
                        <div class="badge mb-2" :class="'badge-'+ (item.transaction.deliveryStatusId == 80 ? 10 : item.transaction.deliveryStatusId)">{{item.statusName}}</div>
                        <div class="fw-bold">{{formatCurrency(item.totalAmountDisplay, 2) || 0}}&nbsp;{{item.transaction.hostCurrency}}</div>
                      </div>
                    </div>

                    <div v-if="(item.transaction.deliveryStatusId == 10 || item.transaction.deliveryStatusId == 80) && item.transaction.agentPaymentStatusId == 5 && item.transaction.settlementId > 0" class="w-100 display-flex justify-content-end pt-sm mt-sm" style="border-top:1px solid var(--f7-color-neutral-gray-40)">
                      <f7-button fill :disabled="false" @click="btnHandleMakePayment(item.transaction)">{{$t('general-text-make-payment')}}</f7-button>
                    </div>
                  </div>

                </f7-list-item>
              </f7-list>
            </div>
          </div>
          <div class="preloader infinite-scroll-preloader" v-show="showLoadingBar"></div>
        <!-- end of Transaction History -->

    </f7-block>
  </f7-page>
</template>

<script>
  import { mapActions }   from "vuex"

  export default {
    mounted (){
      const self = this;

      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        let treshold =20
        let bottomOfWindow = e.target.scrollTop + e.target.clientHeight+treshold >= e.target.scrollHeight;
        if(self.hasMoreItems && bottomOfWindow){
          self.showLoadingBar = true;
          self.loadMore();
        }else{
          this.toggleFooterVisibility(e.target)
        }
      })

      if(self.isTrxCancelled != undefined && self.isTrxCancelled == true){
        self.alertCard.show = true;
      }

      self.getTransactionList(0, self.itemPerPage).then(()=>{
        self.loadTxnHistory();
      });

    },

    data() {
        return{
            alertCard    : {
              show       : false,
              title      : "transaction-cancelled-success",
              content    : "",
              alertClass : "alert-success"
            },
            allowInfinite           : true,
            hasMoreItems            : true,
            showLoadingBar          : false,
            lastItem                : 0,
            itemPerPage             : 10,
            loadingFirstItem        : true,
            routerTo                : "/transaction-history",
            transactionList         : [],
            txnHistoryListViewModel : [],
            isShowEmptyScreen       : false,
        }
    },

    props: {
      isTrxCancelled : Boolean,
    },

    methods: {
        ...mapActions('transaction', [ 'setTransactionDetail', 'resetTransactionFormData' ]),

        afterin(){
          window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
        },
        async getTransactionList(firstIndex, limit){

          const self = this;
          self.transactionList = [];
          if(self.loadingFirstItem){
            self.showPreloader();
          }
          try {
            const result =  await this.$api.transaction.getMyTransactionList(firstIndex,limit,'');
            self.transactionList = result;

            self.loadingFirstItem = false;
            self.showLoadingBar = false;
            // console.log("TRANSACTION HISTORY RESULT");
            // console.log(result);

            self.hidePreloader();
          } catch (error) {
            console.log(error);
            self.loadingFirstItem = false;
            self.showLoadingBar = false;
            self.hidePreloader();
          }
        },

        loadTxnHistory(){
          if(this.transactionList != undefined && this.transactionList.length >0){
            for(let i=0; i < this.transactionList.length; i++) {

              var createdMonth = this.getDateMonthFormat(this.transactionList[i].createdDateTime)
              var createdDate  = this.getDateFormat(this.transactionList[i].createdDateTime)
              var statusName   = this.getDeliveryStatusName(this.transactionList[i].deliveryStatusId,this.transactionList[i].deliveryStatus, this.transactionList[i].agentPaymentStatusId);
              var totalAmountDisplay = this.transactionList[i].totalAmountPaid[0].amount

              this.txnHistoryListViewModel.push({'createdMonth': createdMonth, 'createdDate': createdDate,'statusName':statusName, 'totalAmountDisplay':totalAmountDisplay, 'transaction': this.transactionList[i]});
            }

            this.allowInfinite = true;
            this.hasMoreItems = (this.transactionList.length >= this.itemPerPage);
            this.lastItem += this.transactionList.length;

          }else{
            this.hasMoreItems = false;
          }

          if(this.txnHistoryListViewModel == undefined || this.txnHistoryListViewModel.length <=0){
            this.isShowEmptyScreen = true;
          }
        },

        loadMore(){
          console.log("LOAD MORE GET CALLED");

          const self = this;

          if (!self.allowInfinite){
            return;
          }
          self.allowInfinite = false;

          setTimeout(function () {
            self.getTransactionList(self.lastItem+1, self.itemPerPage).then(()=>{
              self.loadTxnHistory();
            });
          }, 5000);
        },

        isCreatedInSameMonth(index){
          if(index > 0 && (this.txnHistoryListViewModel[index].createdMonth == this.txnHistoryListViewModel[index-1].createdMonth)){
            return true;
          }
          return false;
        },

        getTransactionDetail(selectedTransaction, statusName){
          const self = this
          var transaction = self.$store.state.transaction
          transaction.transactionId          = selectedTransaction.transactionId;
          transaction.transactionStatusName  = statusName;
          transaction.isMakePayment          = false
          transaction.routerTo               = self.routerTo;
          self.alertCard.show                = false;
          self.$f7router.navigate("/transaction-history-details", { transition: 'f7-push' });
        },

        formatCurrency(num, dec) {
          let val = (Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100).toFixed(dec)
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

        btnHandleMakePayment(selectedTrx){
            const self = this
            self.showPreloader()

            //RESET TRANSACTION FORM DATA.
            console.log("START RESET FORM DATA")
            self.resetTransactionFormData()

            // PREPARE PARAMS DETAILS
            var beneficiaryData               = self.$store.state.beneficiary
            var transactionData               = self.$store.state.transaction
            beneficiaryData.beneficiaryId     = selectedTrx.beneficiaryID
            beneficiaryData.homeCountryId     = selectedTrx.homeCountryId
            beneficiaryData.transactionTypeId = selectedTrx.transactionTypeId
            beneficiaryData.deliveryMethodId  = selectedTrx.deliveryMethodId
            beneficiaryData.bankId            = selectedTrx.beneficiaryBankId

            const transactionDetail = this.$api.transaction.getMyTransactionDetails(selectedTrx.transactionId)
            transactionDetail.then(function(result) {
                var trxDetail  = result[0]

                const benePromise = self.$api.beneficiary.getBeneficiaryDetail(beneficiaryData.beneficiaryId, beneficiaryData.transactionTypeId, beneficiaryData.deliveryMethodId, beneficiaryData.bankId)
                benePromise.then(function(result){
                    trxDetail.beneficiaryBankId = result.bankId
                    trxDetail.beneficiaryBank   = result.bank

                    if( trxDetail.deliveryMethodId == 0){
                      trxDetail.billerCode   = result.billerCode
                    }

                    if( trxDetail.deliveryMethodId == 3){
                      trxDetail.beneficiaryBank   = result.collectionAgent
                      trxDetail.beneficiaryBankId = result.collectionAgentId
                    }
                    trxDetail.paymentPurpose = result.paymentPurpose

                    const settlementDetails  = self.$api.settlement.getSettlement(trxDetail.settlementId)
                    settlementDetails.then(function(result) {
                      transactionData.isMakePayment          = true
                      if(result.paymentList !=undefined && result.paymentList.length > 0){
                        transactionData.totalAmountSettlement  = parseFloat(result.totalAmountPayable) + parseFloat(result.paymentList[0].fee)
                        trxDetail.paymentMethod                = result.paymentList[0].paymentMethod
                        trxDetail.paymentMethodId              = result.paymentList[0].paymentMethodId
                      }

                      self.setTransactionDetail(trxDetail)
                      self.$f7router.navigate("/sendmoney/payment-detail")
                      self.hidePreloader()
                    })
                })
            })
        },

        backButton() {
          if(this.isTrxCancelled != undefined && this.isTrxCancelled == true) {
            this.$f7router.back("/home", { transition: 'f7-push', force : true });
          } else {
            this.$f7router.back({ transition: 'f7-push', force : true })
          }
        }
    }
  }
</script>
